import axios, { AxiosResponse } from 'axios';

import config from '@/config';
import store from '@/store';

interface UploadResponse {
  file_handle?: string;
}

export default class FileUpload {
  public static async upload(file: File): Promise<string> {
    if (!store.state.sessionToken) {
      throw new Error('Not logged in.');
    }

    const formData = new FormData();
    formData.append('file', file);

    const response: AxiosResponse<UploadResponse> = await axios({
      method: 'POST',
      url: config.API_ROOT + '/file-upload/',
      data: formData,
      headers: {
        'X-Session': store.state.sessionToken,
        'Content-Type': 'multipart/form-data'
      }
    });

    if (!response.data.file_handle) {
      throw new Error('Missing file handle in response.');
    }

    return response.data.file_handle;
  }
}
